import { useEffect, useState } from 'react';
import { getZonesMapConfig } from './reference-data.api';

/**
 * The deployment's MapTiler key: `undefined` until the answer arrives (so the editor can show a
 * skeleton rather than a false "not configured"), then the key, or `null` when unset or unreachable.
 * Fetched once — the key doesn't change while the page is open.
 */
export function useZonesMapTileKey(): string | null | undefined {
  const [mapTileKey, setMapTileKey] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    getZonesMapConfig()
      .then(({ tileKey }) => tileKey)
      .catch(() => null)
      .then((tileKey) => {
        if (!cancelled) setMapTileKey(tileKey);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return mapTileKey;
}
